import React from "react";
import {observer} from "mobx-react";
import {GermanyRealityCheckDialogBox} from "./boxes/germany.reality-check-dialog.box";
import {GermanyRealityCheckDialogHeaderBox} from "./boxes/germany.reality-check-dialog-header.box";
import {GermanyRealityCheckDialogFooterBox} from "./boxes/germany.reality-check-dialog-footer.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {GermanyRealityCheckDialogFieldLabelBox} from "./boxes/germany.reality-check-dialog-field-label.box";
import {GermanyRealityCheckDialogFieldValueBox} from "./boxes/germany.reality-check-dialog-field-value.box";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";
import {GermanyRealityCheckDialogButtonsBox} from "./boxes/germany.reality-check-dialog-buttons.box";
import {CyClass} from "../../../../common/cy-classes";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {DISPLAY_MESSAGE_NAMES} from "../../../../common/const/casinofied-analytics-consts";


interface GermanyRealityCheckDialogComponentProps extends ComponentServicesPick<'gameRunner'>{
    dialogHandler: IModalDialogHandler;
    businessCorrelationId: string;
    totalNetLoss: number;
}



const ComponentBody: React.FC<GermanyRealityCheckDialogComponentProps> = observer((props) => {
    const services = useServices();

    const isGameRunning = Boolean(props.gameRunner.currentRunningGame);

    const sendAnalytics = (action: string) => {
        services.analytics.sendAnalytics('reality_check_message', action);
    }

    const sendMessageActionTaken = () => {
        services.casinofiedAnalytics.messageActionTaken({
            businessCorrelationID: props.businessCorrelationId,
            displayMessageName: DISPLAY_MESSAGE_NAMES.REALITY_CHECK_GERMANY_MESSAGE_NAME,
            actionType: "Confirmation"
        });
    }

    const onCloseGame = async () => {

        sendAnalytics('close_game');

        sendMessageActionTaken();

        await props.gameRunner.currentRunningGame?.closeGame({
            shouldSuggestNextGame: false
        });

        props.dialogHandler.close();
    }

    const onContinue = async () => {
        if(isGameRunning) {
            sendAnalytics('continue_in_game')
        } else {
            sendAnalytics('continue_in_lobby')
        }

        sendMessageActionTaken();

        props.dialogHandler.close();
    }


    const renderContinueButton = () => {
        return (
            <Button preset="primary" onClick={onContinue} className={CyClass('cy-reality-check-close-button')}>
                {services.translation.translate('REALITY_CHECK_DIALOG_CONTINUE_BUTTON')}
            </Button>
        )
    }

    const renderButtons = () => {
        if(isGameRunning) {
            return (
                <>
                    <Button preset="secondary" onClick={onCloseGame}>
                        {services.translation.translate('CLOSE_GAME')}
                    </Button>

                    {renderContinueButton()}

                </>
            )
        }

        return renderContinueButton()


    }

    const formatSessionTime = () => {
        const sessionTime = services.sessionTimer.currentSessionTimer;
        return sessionTime.hours.toString().padStart(2, '0') + 'h:' + sessionTime.minutes.toString().padStart(2, '0') + 'm';
    }

    return (
        <GermanyRealityCheckDialogBox>
            <GermanyRealityCheckDialogHeaderBox>
                {services.translation.translate('REALITY_CHECK_DIALOG_HEADER_TEXT')}
            </GermanyRealityCheckDialogHeaderBox>

            <GermanyRealityCheckDialogFieldLabelBox>
                {services.translation.translate('REALITY_CHECK_DIALOG_SESSION_TIMER_LABEL')}
            </GermanyRealityCheckDialogFieldLabelBox>

            <GermanyRealityCheckDialogFieldValueBox>
                {formatSessionTime()}
            </GermanyRealityCheckDialogFieldValueBox>

            <GermanyRealityCheckDialogFieldLabelBox>
                {
                    props.totalNetLoss >= 0
                        ? services.translation.translate('REALITY_CHECK_DIALOG_SESSION_LOSSES_LABEL')
                        : services.translation.translate('REALITY_CHECK_DIALOG_SESSION_WINNINGS_LABEL')
                }
            </GermanyRealityCheckDialogFieldLabelBox>

            <GermanyRealityCheckDialogFieldValueBox>
                {services.currency.formatMoney(Math.abs(props.totalNetLoss))}
            </GermanyRealityCheckDialogFieldValueBox>

            <GermanyRealityCheckDialogFooterBox>
                {services.translation.translate('REALITY_CHECK_DIALOG_THANK_YOU_MESSAGE')}
            </GermanyRealityCheckDialogFooterBox>

            <GermanyRealityCheckDialogButtonsBox className={CyClass('cy-modal-dialog-buttons-area')}>
                {renderButtons()}
            </GermanyRealityCheckDialogButtonsBox>
        </GermanyRealityCheckDialogBox>
    )
})

export const GermanyRealityCheckDialogComponent = withServices(ComponentBody, ['gameRunner']);